<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newOperator()"
                aria-label="New Operator">
            New
        </button>
    </div>

    <div class="nav material2">

        <!--        <div class="nav-item" *ngFor="let tag of tags">-->
        <!--            <a class="nav-link" matRipple [routerLink]="'/apps/todo/tag/' + tag.handle"-->
        <!--               [routerLinkActive]="['active', 'accent']">-->
        <!--                <mat-icon class="nav-link-icon" [ngStyle]="{'color':tag.color}">label</mat-icon>-->
        <!--                <span>{{tag.title}}</span>-->
        <!--            </a>-->
        <!--        </div>-->

    </div>

</div>
<!-- / SIDEBAR CONTENT -->
